<script setup lang="ts">
import router from '@/router'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import {
  useCreateInflowSourceDefinitionMutation,
  useFetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery,
} from './SettingsPageLineActivationInflowSourceView.generated'
import SettingPageLineActivationInflowSourceForm, {
  type InflowSourceDefinitionForm,
} from './SettingPageLineActivationInflowSourceForm.vue'
import { useAlert } from '@/libs/alertPortal'

const alert = useAlert()

const form = {
  inflowSourceName: '',
  useShortenedURL: false,
  matchAssigendStaffs: [],
}

const { result } =
  useFetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery()

const { mutate } = useCreateInflowSourceDefinitionMutation()

const save = async (v: InflowSourceDefinitionForm) => {
  await mutate({
    input: {
      inflowSourceName: v.inflowSourceName,
      useShortenedURL: v.useShortenedURL,
      matchAssignedStaffGUIDs: v.matchAssigendStaffs,
    },
  })

  alert.success('追加しました')

  // eslint-disable-next-line fp/no-mutating-methods
  router.push({ name: 'LineActivationSettingInflowSource' })
}
</script>

<template>
  <SettingsPagePanel>
    <SettingsPagePanelHeader>
      <template #title>友だち追加経路 追加</template>
    </SettingsPagePanelHeader>
    <SettingPageLineActivationInflowSourceForm
      v-if="result"
      :form="form"
      :fragment="result"
      @save="save"
    />
  </SettingsPagePanel>
</template>
